import { SNACKBAR_SUCCESS, SNACKBAR_CLEAR } from "../Types";

export const showSuccessSnackbar = message => dispatch => {
  dispatch({ type: SNACKBAR_SUCCESS, message });
};

export const clearSnackbar = () => dispatch => {
  dispatch({ type: SNACKBAR_CLEAR });
};
